import { AvailabilityStatus, CheckInStatusEnum } from 'garaje/services/live-map';

export function createURNFromId(id) {
  return `urn:envoy:employee:${id}`;
}

export function createResourceState(resourceModel, resourceType, availabilityStatus, reservationId, employeeId) {
  const hasReservation = availabilityStatus !== AvailabilityStatus.AVAILABLE && reservationId != null;
  return {
    resourceId: resourceModel.id,
    resourceType: resourceType,
    assignedTo:
      availabilityStatus !== AvailabilityStatus.AVAILABLE && employeeId != null ? createURNFromId(employeeId) : null,
    status: {
      availabilityStatus: availabilityStatus,
      reservationId: hasReservation ? reservationId : null,
      checkInStatus: hasReservation
        ? {
            status: CheckInStatusEnum.PENDING,
          }
        : null,
      reservedFor: hasReservation ? createURNFromId(employeeId) : null,
    },
  };
}
